/**
 * Contact Form 7 のバリデーションメッセージを、送信ボタンを押したあとだけ表示する。
 * フォームは AJAX で差し替わるためイベント委譲で監視する。
 */
export const initContactForm = () => {
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.js-form-submit')) return;

    document
      .querySelectorAll('.wpcf7-form-control-wrap')
      .forEach((wrap) => wrap.classList.add('is-show'));
  });
};
